import React from 'react';
import { Link } from "react-router-dom";
import firebase, { auth, provider } from './firebase/firebase.js';


export default class Authentication extends React.Component {
    constructor()
    {
      super();
      this.state =
      {
        user:null
      }
      this.login = this.login.bind(this);
      this.logout = this.logout.bind(this);

    }
    logout() {
        auth.signOut()
        .then(() => {
          this.setState({
            user: null
          });
        });      }
      login() {
        auth.signInWithPopup(provider) 
          .then((result) => {
            const user = result.user;
            this.setState({
              user
            });
          });
      }

      componentDidMount(){
        auth.onAuthStateChanged((user) => {
            if (user) {
              this.setState({ user });
            } 
          });
      }
      render()
      {
          return ""
      }
    }
